import TableOrder from "components/base/TableOrder/TableOrder";
import formatCurrency from "utils/formatCurrency";
import useGetYourOrderContent from "hooks/content/useGetYourOrderContent";
import useGetData from "hooks/api/useGetData";
import { useParams } from "react-router-dom";
import { COMPANY_FLOW_TYPE } from "constants/flowTypes";
import { useTranslation } from "react-i18next";
import useGetQuote from "hooks/api/useGetQuote";
import useGetPrice from "hooks/utils/useGetPrice";

interface YourOrderProps {
  isLoading?: boolean;
}

const YourOrder = ({ isLoading }: YourOrderProps) => {
  const { isLoading: isLoadingData } = useGetData();
  const { subtotalPrice, totalPrice } = useGetPrice();
  const rows = useGetYourOrderContent();
  const { quote } = useGetQuote();
  const { type: flowType } = useParams();
  const { t } = useTranslation();

  const headings =
    flowType === COMPANY_FLOW_TYPE
      ? []
      : [
          {
            title: t("yourOrder.product"),
            xs: 3
          },
          {
            title: t("yourOrder.quantity"),
            xs: 2
          },
          {
            title: t("yourOrder.price"),
            xs: 3
          },
          {
            title: t("yourOrder.priceTotal"),
            xs: 4
          }
        ];

  const footerRows = [
    {
      title: "Sub Total",
      value: formatCurrency(subtotalPrice)
    },
    {
      title: t("yourOrder.fees"),
      value: formatCurrency(quote),
      highlight: true
    },
    {
      title: t("yourOrder.total"),
      value: formatCurrency(totalPrice)
    }
  ];

  const content = {
    rows,
    headings
  };

  const loading = flowType !== COMPANY_FLOW_TYPE ? isLoadingData || isLoading : false;

  return <TableOrder isLoading={loading} content={content} footerRows={footerRows} />;
};

export default YourOrder;
